import { useLocation, useNavigate } from 'react-router';

import { buildTemplatesUrl } from '@/shared/lib';

import {
  createTemplatesNavigationState,
  getPathWithSearch,
  getTemplatesPagePath,
  type TemplatesNavigationState,
} from '../lib';

// The Templates page's Back returns to the page it was opened from.
export const useOpenTemplatesPage = (seriesId?: string, classic = false) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  return () => {
    const state: TemplatesNavigationState = {
      ...createTemplatesNavigationState(getPathWithSearch(pathname, search)),
      pushedFromBackPath: true,
    };
    navigate(classic ? buildTemplatesUrl() : getTemplatesPagePath(seriesId), {
      state,
    });
  };
};
